/**
 * Site-wide JS settings.
 * Keep breakpoint values in sync with `src/scss/_settings.scss`
 * and the `below` / `above` mixins in `src/scss/_tools.scss`.
 */
const Settings = {
    /** Mirrors `$breakpoint-mobile` */
    breakpointMobile: 768,

    /** Mirrors `$breakpoint-tablet` */
    breakpointTablet: 1024,

    /** Mirrors `$breakpoint-property-icon` */
    breakpointPropertyIcon: 1160,

    /**
     * Matches `tools.below($breakpoint-mobile)`:
     * `@media (max-width: calc(#{$breakpoint} - 0.02px))`
     */
    get mobileMq() {
        return `(max-width: ${this.breakpointMobile - 0.02}px)`
    },

    /**
     * Title slot only: above `$breakpoint-tablet` and below `$breakpoint-property-icon`.
     */
    get propertyIconInTitleMq() {
        const min = this.breakpointTablet + 0.02
        const max = this.breakpointPropertyIcon - 0.02
        return `(min-width: ${min}px) and (max-width: ${max}px)`
    },
}

export default Settings
